import { Component, Input, OnChanges, Output, EventEmitter } from '@angular/core'
import { Observable } from 'rxjs'
import { Utils } from '../../../helpers'
import { BaseModel } from '../../../data/models'
import { IEntityListConfig, IDisplayedClass, IDisplayedColumn, IActionColumn } from '../../../'

@Component({
  selector: 'mp-entity-list',
  templateUrl: './entity-list.html'
})
export class EntityListComponent implements OnChanges {
  @Input() public entities: Observable<BaseModel[]>
  @Input() public config: IEntityListConfig

  @Output() public editClicked = new EventEmitter()

  public get displayedColumns() {
    return this.config.displayedColumns
  }

  public get actionColumns() {
    return this.config.actionColumns
  }

  public constructor(
    private _utils: Utils
  ) {}

  public ngOnChanges(changes) {
    if (changes.config) { this._normalizeDisplayedColumns() }
  }

  public onEditClicked(entity) {
    this.editClicked.emit(entity)
  }

  private _normalizeDisplayedColumns() {
    const defaultValueGetterStrategy = this._defaultValueGetterStrategy.bind(this)
    this.config.displayedColumns.forEach((displayedColumn) => {
      displayedColumn.value = displayedColumn.value || defaultValueGetterStrategy
    })
  }

  private _defaultValueGetterStrategy(model: BaseModel, displayedColumn) {
    const propertyName = displayedColumn.classProperty || this._utils.camelCase(displayedColumn.label)

    return model[propertyName]
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/angular/components/entity-list/entity-list.component.ts